module.exports = __webpack_public_path__ + "img/gamble_feature.8c287877.png";